export default "__VITE_ASSET__abe62744__"